import { Option } from 'components/shared/configConstructor/types';
import CONSTANTS from 'components/shared/constants';

export const orderValue = (m: Option) => (m.attributes?.order ? m.attributes.order : CONSTANTS.HIGHEST_SORT_ORDER);

export const mapType = (type: string): string => {
  const numberTypes = ['int16', 'int32', 'int64', 'uint16', 'uint32', 'uint64', 'float', 'double', 'decimal'];
  const textTypes = ['string'];

  if (numberTypes.some((t) => t === type)) {
    return 'number';
  }
  if (textTypes.some((t) => t === type)) {
    return 'text';
  }
  return type;
};

export const isFloatingPointNumber = (type: string): boolean => {
  const types = ['float', 'double', 'decimal'];

  return types.some((t) => t === type);
};

export const isInteger = (type: string): boolean => {
  const types = ['int16', 'int32', 'int64', 'uint16', 'uint32', 'uint64'];

  return types.some((t) => t === type);
};

export const isNullableInteger = (type: string): boolean => {
  const types = ['nullableint32'];

  return types.some((t) => t === type);
};

export const isNullableFloatingPointNumber = (type: string): boolean => {
  const types = ['nullabledecimal'];

  return types.some((t) => t === type);
};
